import { useEffect, useRef, useState } from "react"

const REFERENCE_DATE_REFRESH_MS = 60 * 1000

export function useRefreshingReferenceDate(enabled = true): Date {
  const [referenceDate, setReferenceDate] = useState(() => new Date())
  const wasEnabled = useRef(enabled)

  useEffect(() => {
    if (!enabled || typeof window === "undefined") {
      wasEnabled.current = false
      return
    }

    if (!wasEnabled.current) {
      setReferenceDate(new Date())
    }
    wasEnabled.current = true
    const intervalId = window.setInterval(() => {
      setReferenceDate(new Date())
    }, REFERENCE_DATE_REFRESH_MS)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [enabled])

  return referenceDate
}
